/*
  Barklie "Try now"-knoppen op de productpagina (S11, 13 okt 2026).
  Volgens referentie: een link naar #pdp-title scrollt zacht naar de producttitel bovenaan (titel landt direct
  onder de vaste header, via scroll-margin-top in barklie.css), zonder #-adres in de URL.
  Reduced motion: direct springen. Geen producttitel op de pagina: gewone link.
  Wordt door meerdere secties geladen; de handler wordt maar één keer gezet.
  Collectiepagina (13 okt 2026): data-bk-scroll-top="<id>" scrollt naar dat element (bijv. het productraster
  #shop-hip-joint-mobility, zoals "Shop Hip & Joint" bij referentie); leeg = #pdp-title.
*/
(function () {
  if (window.bkScrollTop) return;
  window.bkScrollTop = true;

  var reduce = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;

  document.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var link = e.target.closest ? e.target.closest('a[data-bk-scroll-top]') : null;
    if (!link) return;
    var target = document.getElementById(link.getAttribute('data-bk-scroll-top') || 'pdp-title');
    if (!target) return;
    e.preventDefault();
    target.scrollIntoView({ behavior: reduce && reduce.matches ? 'auto' : 'smooth', block: 'start' });
  });
})();
